import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5edbd33a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "responsive-table" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_5 = { class: "ion-text-center" }
const _hoisted_6 = { class: "input-cell" }
const _hoisted_7 = { class: "input-cell" }
const _hoisted_8 = { class: "input-cell" }
const _hoisted_9 = { class: "flex-container" }
const _hoisted_10 = { class: "ion-justify-content-center" }
const _hoisted_11 = {
  key: 0,
  class: "new-row"
}
const _hoisted_12 = { class: "input-cell" }
const _hoisted_13 = { class: "flex-container" }
const _hoisted_14 = { class: "ion-justify-content-center" }
const _hoisted_15 = { class: "ion-margin" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_auto_fill_select = _resolveComponent("auto-fill-select")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_alert = _resolveComponent("ion-alert")!
  const _component_BaseLayout = _resolveComponent("BaseLayout")!

  return (_openBlock(), _createBlock(_component_BaseLayout, null, {
    title: _withCtx(() => [
      (_ctx.userInfo && _ctx.userInfo.user_type == 'member')
        ? (_openBlock(), _createBlock(_component_ion_title, {
            key: 0,
            class: "ion-hide-sm-down"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('CampaignForm')) + " " + _toDisplayString(_ctx.campaign.year), 1)
            ]),
            _: 1
          }))
        : (_ctx.campaign)
          ? (_openBlock(), _createBlock(_component_ion_title, { key: 1 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.campaign.name), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
    ]),
    content: _withCtx(() => [
      (!_ctx.dataLoaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ion_spinner),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('LoadingData')), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "ion-justify-content-between ion-margin-bottom" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          href: `/exploitation/${_ctx.slug}/cultures/`,
                          class: "ion-float-md-left",
                          color: "light"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('BackToCampaignsDashboard')), 1)
                          ]),
                          _: 1
                        }, 8, ["href"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          href: `/exploitation/${_ctx.slug}/cultures/${_ctx.campaign.year}`,
                          class: "ion-float-md-right",
                          color: "secondary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('SeeCampaignData')), 1)
                          ]),
                          _: 1
                        }, 8, ["href"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, { class: "ion-hide-sm-up" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('CampaignForm')) + " " + _toDisplayString(_ctx.campaign.year), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("form", {
              onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("table", null, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Crops')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Type')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Bio')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('MixedCrop')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Precision')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('YieldTargetAbbr')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('SalePrice')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Statut')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Fill')), 1),
                    _hoisted_4
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaign.crops, (crop, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          _createVNode(_component_auto_fill_select, {
                            options: _ctx.harvests,
                            searchField: "crop_name",
                            label: _ctx.translations[_ctx.currentLanguage].Crop,
                            placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                            selected: crop.crop_name,
                            clear: false,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = option => _ctx.handleSelected(option, _ctx.item, 'harvest', true))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" >")
                            ]),
                            _: 2
                          }, 1032, ["options", "label", "placeholder", "selected"])
                        ]),
                        _createElementVNode("td", _hoisted_5, [
                          _createVNode(_component_ion_select, {
                            "aria-label": _ctx.translations[_ctx.currentLanguage].CropType,
                            placeholder: _ctx.translations[_ctx.currentLanguage].CropTypePlaceholder,
                            modelValue: _ctx.campaign.crops[index].crop_type,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.campaign.crops[index].crop_type) = $event),
                            onIonChange: ($event: any) => (_ctx.updateCropData($event, _ctx.campaign.crops[index])),
                            "cancel-text": _ctx.translations[_ctx.currentLanguage].Cancel,
                            "ok-text": _ctx.translations[_ctx.currentLanguage].Choose
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cropTypes, (crop_type, index_crop_type) => {
                                return (_openBlock(), _createBlock(_component_ion_select_option, {
                                  key: index_crop_type,
                                  value: crop_type.id,
                                  selected: _ctx.isSelected(crop_type.id, crop.crop_type)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(crop_type.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "selected"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["aria-label", "placeholder", "modelValue", "onUpdate:modelValue", "onIonChange", "cancel-text", "ok-text"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_ion_checkbox, {
                            "aria-label": _ctx.translations[_ctx.currentLanguage].Bio,
                            checked: crop.bio,
                            modelValue: _ctx.campaign.crops[index].bio,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.campaign.crops[index].bio) = $event),
                            onIonChange: ($event: any) => (_ctx.updateCropData($event, _ctx.campaign.crops[index]))
                          }, null, 8, ["aria-label", "checked", "modelValue", "onUpdate:modelValue", "onIonChange"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_ion_checkbox, {
                            "aria-label": _ctx.translations[_ctx.currentLanguage].MixedCrop,
                            checked: crop.mixed,
                            modelValue: _ctx.campaign.crops[index].mixed,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.campaign.crops[index].mixed) = $event),
                            onIonChange: ($event: any) => (_ctx.updateCropData($event, _ctx.campaign.crops[index]))
                          }, null, 8, ["aria-label", "checked", "modelValue", "onUpdate:modelValue", "onIonChange"])
                        ]),
                        _createElementVNode("td", _hoisted_6, [
                          _createVNode(_component_ion_input, {
                            "aria-label": _ctx.translations[_ctx.currentLanguage].Precision,
                            value: crop.precision,
                            modelValue: _ctx.campaign.crops[index].precision,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.campaign.crops[index].precision) = $event),
                            onIonBlur: ($event: any) => (_ctx.updateCropData($event, _ctx.campaign.crops[index]))
                          }, null, 8, ["aria-label", "value", "modelValue", "onUpdate:modelValue", "onIonBlur"])
                        ]),
                        _createElementVNode("td", _hoisted_7, [
                          _createVNode(_component_ion_input, {
                            "aria-label": _ctx.translations[_ctx.currentLanguage].YieldTarget,
                            value: crop.area.crop_yield_target,
                            modelValue: _ctx.campaign.crops[index].area.crop_yield_target,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.campaign.crops[index].area.crop_yield_target) = $event),
                            onIonBlur: ($event: any) => (_ctx.updateProductionPrice($event, _ctx.campaign.crops[index]))
                          }, null, 8, ["aria-label", "value", "modelValue", "onUpdate:modelValue", "onIonBlur"])
                        ]),
                        _createElementVNode("td", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_ion_input, {
                              "aria-label": _ctx.translations[_ctx.currentLanguage].SalePrice,
                              type: "number",
                              min: "0",
                              modelValue: _ctx.campaign.crops[index].sale_price,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.campaign.crops[index].sale_price) = $event),
                              modelModifiers: { number: true },
                              onIonBlur: ($event: any) => (_ctx.updateCropData($event, _ctx.campaign.crops[index])),
                              class: "ion-text-center"
                            }, null, 8, ["aria-label", "modelValue", "onUpdate:modelValue", "onIonBlur"]),
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProT')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(crop.progressStatus), 1),
                        _createElementVNode("td", null, _toDisplayString(crop.progress) + " %", 1),
                        _createElementVNode("td", _hoisted_10, [
                          (_ctx.canUnsubmit(crop))
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 0,
                                title: _ctx.translations[_ctx.currentLanguage].UnsubmitCrop,
                                color: "light",
                                onClick: ($event: any) => (_ctx.unsubmit(crop))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.chevronBackOutline }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["title", "onClick"]))
                            : _createCommentVNode("", true),
                          (_ctx.canUpdate(crop))
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 1,
                                title: _ctx.translations[_ctx.currentLanguage].EditCrop,
                                color: "secondary",
                                href: `/exploitation/${_ctx.slug}/cultures/${_ctx.year}/saisie/${crop.id}/`
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["title", "href"]))
                            : _createCommentVNode("", true),
                          (_ctx.canDelete(crop))
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 2,
                                title: _ctx.translations[_ctx.currentLanguage].DeleteCrop,
                                color: "danger",
                                onClick: ($event: any) => (_ctx.setOpen(true, crop.id))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["title", "onClick"]))
                            : _createCommentVNode("", true),
                          (_ctx.canSee(crop))
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 3,
                                title: _ctx.translations[_ctx.currentLanguage].SeeCrop,
                                color: "tertiary",
                                href: `/exploitation/${_ctx.slug}/cultures/${_ctx.year}/consultation/${crop.id}/`
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.eyeOutline }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["title", "href"]))
                            : _createCommentVNode("", true),
                          (_ctx.canUnvalidate(crop))
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 4,
                                title: _ctx.translations[_ctx.currentLanguage].UnvalidateCrop,
                                color: "light",
                                onClick: ($event: any) => (_ctx.unvalidate(crop))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.chevronBackOutline }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["title", "onClick"]))
                            : _createCommentVNode("", true),
                          (_ctx.canValidate(crop))
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 5,
                                title: _ctx.translations[_ctx.currentLanguage].ValidateCrop,
                                color: "primary",
                                onClick: ($event: any) => (_ctx.validate(crop))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.checkmarkOutline }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["title", "onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128)),
                    (_ctx.canAdd)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                          _createElementVNode("td", null, [
                            _createVNode(_component_auto_fill_select, {
                              options: _ctx.harvests,
                              searchField: "crop_name",
                              ref: "selectCrop",
                              label: _ctx.translations[_ctx.currentLanguage].Crop,
                              placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = option => _ctx.handleSelected(option, _ctx.newCrop, 'harvest', false))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" >")
                              ]),
                              _: 1
                            }, 8, ["options", "label", "placeholder"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_ion_select, {
                              "aria-label": _ctx.translations[_ctx.currentLanguage].CropType,
                              placeholder: _ctx.translations[_ctx.currentLanguage].CropTypePlaceholder,
                              modelValue: _ctx.newCrop.crop_type,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newCrop.crop_type) = $event)),
                              "cancel-text": _ctx.translations[_ctx.currentLanguage].Cancel,
                              "ok-text": _ctx.translations[_ctx.currentLanguage].Choose
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cropTypes, (crop_type, index_crop_type) => {
                                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                                    key: index_crop_type,
                                    value: crop_type.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(crop_type.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["aria-label", "placeholder", "modelValue", "cancel-text", "ok-text"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_ion_checkbox, {
                              "aria-label": _ctx.translations[_ctx.currentLanguage].Bio,
                              modelValue: _ctx.newCrop.bio,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newCrop.bio) = $event))
                            }, null, 8, ["aria-label", "modelValue"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_ion_checkbox, {
                              "aria-label": _ctx.translations[_ctx.currentLanguage].MixedCrop,
                              modelValue: _ctx.newCrop.mixed,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newCrop.mixed) = $event))
                            }, null, 8, ["aria-label", "modelValue"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_ion_input, {
                              "aria-label": _ctx.translations[_ctx.currentLanguage].Precision,
                              modelValue: _ctx.newCrop.precision,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newCrop.precision) = $event)),
                              fill: "solid"
                            }, null, 8, ["aria-label", "modelValue"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_ion_input, {
                              "aria-label": _ctx.translations[_ctx.currentLanguage].YieldTarget,
                              modelValue: _ctx.newCrop.area.crop_yield_target,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newCrop.area.crop_yield_target) = $event)),
                              fill: "solid"
                            }, null, 8, ["aria-label", "modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_ion_input, {
                                "aria-label": _ctx.translations[_ctx.currentLanguage].SalePrice,
                                type: "number",
                                min: "0",
                                modelValue: _ctx.newCrop.sale_price,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newCrop.sale_price) = $event)),
                                modelModifiers: { number: true },
                                class: "ion-text-center"
                              }, null, 8, ["aria-label", "modelValue"]),
                              _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProT')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.newCrop.progressStatus), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.newCrop.progress) + " %", 1),
                          _createElementVNode("td", _hoisted_14, [
                            _createVNode(_component_ion_button, { onClick: _ctx.addCrop }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('Add')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 32),
            _createElementVNode("div", _hoisted_15, [
              (_ctx.errorMessage)
                ? (_openBlock(), _createBlock(_component_ion_text, {
                    key: 0,
                    color: "danger"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_ion_alert, {
              "is-open": _ctx.showDeleteCropConfirmation,
              header: _ctx.translations[_ctx.currentLanguage].DeleteCropTitle,
              message: _ctx.translations[_ctx.currentLanguage].DeleteCropMessage,
              buttons: _ctx.alertButtons,
              onDidDismiss: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setOpen(false, 0)))
            }, null, 8, ["is-open", "header", "message", "buttons"])
          ]))
    ]),
    _: 1
  }))
}